import React from "react";
import { connect } from "react-redux";
// import { isConnected } from "services/chromecast";

// const castDisabledIcon = "./assets/icon/ic_mr_button_disabled_dark.png";

export interface Props {}

// Chromecast related Typescript
declare global {
  namespace JSX {
    interface IntrinsicElements {
      ["google-cast-launcher"]: React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
    }
  }
}

const ChromeCastIcon: React.FC<Props> = () => {
  const getIcon: () => string = () => {
    // if (isConnected()) {
    return "./assets/icon/chromecast_light/ic_mr_button_connected_00_dark.png";
    // } else {
    //   return castDisabledIcon;
    // }
    // return castDisabledIcon;
  };

  return (
    <img
      className="fabIcon"
      src={getIcon()}
      alt="Cast"
      style={{ maxWidth: "65%" }}
    ></img>
  );
  //return <google-cast-launcher id="castbutton"></google-cast-launcher>;
};

const mapStateToProps = (state: any) => ({
  user: state.user.userDetails,
  quizData: state.quiz,
});

export default connect(mapStateToProps, {})(ChromeCastIcon);
